import { render, staticRenderFns } from "./Sabrina.vue?vue&type=template&id=7280c037&scoped=true&"
import script from "./Sabrina.vue?vue&type=script&lang=js&"
export * from "./Sabrina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7280c037",
  null
  
)

export default component.exports